'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TYPE_VALIDATORS;

var _validationConstants = require('../validationConstants');

var _emailValidator = require('./type/emailValidator');

var _emailValidator2 = _interopRequireDefault(_emailValidator);

var _passwordValidator = require('./type/passwordValidator');

var _passwordValidator2 = _interopRequireDefault(_passwordValidator);

var _dateValidator = require('./type/dateValidator');

var _dateValidator2 = _interopRequireDefault(_dateValidator);

var _selectValidator = require('./type/selectValidator');

var _selectValidator2 = _interopRequireDefault(_selectValidator);

var _urlValidator = require('./type/urlValidator');

var _urlValidator2 = _interopRequireDefault(_urlValidator);

var _elementIdValidator = require('./type/elementIdValidator');

var _elementIdValidator2 = _interopRequireDefault(_elementIdValidator);

var _htmlValidator = require('./type/htmlValidator');

var _htmlValidator2 = _interopRequireDefault(_htmlValidator);

var _objectValidator = require('./type/objectValidator');

var _objectValidator2 = _interopRequireDefault(_objectValidator);

var _objectIdValidator = require('./type/objectIdValidator');

var _objectIdValidator2 = _interopRequireDefault(_objectIdValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE_VALIDATORS = (_TYPE_VALIDATORS = {}, _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.email, _emailValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.password, _passwordValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.date, _dateValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.select, _selectValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.url, _urlValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.elementId, _elementIdValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.html, _htmlValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.object, _objectValidator2.default), _defineProperty(_TYPE_VALIDATORS, _validationConstants.FIELD_TYPES.objectId, _objectIdValidator2.default), _TYPE_VALIDATORS);

/**
 */

exports.default = function (fieldValue, validationConfig) {
    // If we specifically don't want to do type validation, then immediately return null
    if (validationConfig.disableTypeValidation) return null;

    var typeValidator = TYPE_VALIDATORS[validationConfig.type];

    return typeValidator ? typeValidator(fieldValue, validationConfig) : null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/typeValidator.js
// module id = 2311
// module chunks = 0